(function () {
    'use strict';

    angular.module("imApp").factory("custactMemberEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getActivityMember: function (parms) {
                return $ihttp.post({
                    method: 93,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 94,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 97,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
